exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscribe__popup{justify-content:space-between}.ainoxform,.subscribe__popup{display:flex;flex-direction:column;gap:24px}", ""]);

// exports
